import Cookies from "js-cookie"


const CurrUser = () => {
    let roles = Cookies.get('type')?.split(',') ?? []

    const role = roles[0].substring(0, 40)

    let result = ''
    if (role == process.env.REACT_APP_STL)
        result = 'student'
    else if (role == process.env.REACT_APP_SUL)
        result = 'supervisor'
    else if (role == process.env.REACT_APP_AL)
        result = 'admin'


    return result
}


export default CurrUser

